// extracted by mini-css-extract-plugin
export default {"container":"demo-time-control_container__SmWlt","almost-invisible":"demo-time-control_almost-invisible__29HE2"};